import { create } from 'zustand';

/** Window scroll positions remembered per listing (e.g. `home`, `search`, `collection:<slug>`). */
interface ScrollState {
  positions: Record<string, number>;
  remember: (key: string, scrollY: number) => void;
  forget: (...keys: string[]) => void;
}

export const useScrollStore = create<ScrollState>((set) => ({
  positions: {},
  remember: (key, scrollY) => set((state) => ({ positions: { ...state.positions, [key]: scrollY } })),
  forget: (...keys) =>
    set((state) => ({
      positions: { ...state.positions, ...Object.fromEntries(keys.map((key) => [key, 0])) },
    })),
}));
